'use client';

import React from 'react';

import Image from 'next/image';

import HtmlRenderer from '@/components/HtmlRender';
// import tickIcon from '@/assets/images/lead-check-icon.svg';

import Container from '@/components/V2/Container';
import { replaceLastPartOfUrl } from '@/helpers/utils/common';
import { SecondarySectionDetails } from '@/types/LeadGeneration';

import { useImageData } from '../hooks/useImageData';

type SecondarySectionProps = {
  secondarySectionData?: SecondarySectionDetails;
};

const SecondarySection = ({ secondarySectionData }: SecondarySectionProps) => {
  if (secondarySectionData?.contentPhoto) {
    secondarySectionData.contentPhoto.url = replaceLastPartOfUrl(secondarySectionData.contentPhoto?.url, 'hd');
  }

  const { image: imageDesktop } = useImageData(secondarySectionData?.contentPhoto, 500, 500);
  const { image: imageMobile } = useImageData(secondarySectionData?.contentPhotoMobile, 500, 500);

  const headline = secondarySectionData?.contentHeading ?? '';
  const description = secondarySectionData?.contentDescription;

  return (
    <div className="v2-relative v2-overflow-hidden md:v2-overflow-hidden xs:v2-overflow-auto sm:v2-overflow-auto">
      <div className="v2-absolute v2-right-0 v2-h-[672px] md:v2-h-[672px] sm:v2-h-auto xs:v2-h-auto v2-bottom-0 -v2-z-[1] sm:v2-hidden xs:v2-hidden md:v2-flex md:v2-justify-center md:v2-items-end v2-w-full">
        <Image
          alt={imageDesktop.alt}
          src={imageDesktop.url}
          width={1000}
          height={1000}
          layout="responsive"
          quality={100}
          className="v2-relative v2-max-w-full v2-block v2-w-full v2-h-auto v2-object-cover !v2-h-full"
        />
      </div>
      <div className="md:v2-hidden sm:v2-flex xs:v2-flex">
        <Image
          alt={imageMobile.alt}
          src={imageMobile.url}
          width={imageMobile.width}
          height={imageMobile.height}
          layout="responsive"
          quality={100}
          className="v2-relative v2-max-w-full"
        />
      </div>
      <Container className="v2-pt-[66px] md:v2-px-[56px] lg:v2-px-[16px] xs:v2-pt-0 sm:v2-pt-0 md:v2-pt-[66px] v2-pb-[0px] md:v2-pb-[80px] xs:v2-pb-[138px] sm:v2-pb-[138px] v2-min-h-[666px]">
        <div className="v2-grid v2-grid-cols-2 xs:v2-grid-cols-1 sm:v2-grid-cols-1 md:v2-grid-cols-2">
          <div className="v2-flex v2-flex-col">
            <h2 className="v2-text-4xl md:v2-text-4xl xs:v2-text-3xl sm:v2-text-3xl v2-text-[#212427] v2-font-sweet-sans-pro v2-font-normal v2-mb-8">
              {headline}
            </h2>
            {description?.visible && (
              // <div
              //   className="lead-generation"
              //   dangerouslySetInnerHTML={{ __html: sanitize(description?.value ?? '') }}
              // />
              <HtmlRenderer className="lead-generation" html={description?.value ?? ''} />
            )}

            {/* <p className="v2-text-lg md:v2-text-lg xs:v2-text-base sm:v2-text-base v2-font-sweet-sans-pro-semi-bold v2-font-semibold v2-text-[#212427]">
              {secondarySectionData?.CallToActionCopy}
            </p> */}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SecondarySection;
